<template>
    <div class="micrositio-section">
        <div class="micrositio-content">
            <h2 class="micrositio-title fuente-posm">
                Tu Propio Micrositio de Facturación
            </h2>
            <p class="micrositio-text fuente-nova">
                Ofrece a tus clientes una forma ágil, clara y personalizada para generar sus facturas.
                <br><br>
                Nuestro micrositio se adapta a la imagen de tu marca y te permite definir reglas como fechas límite, tipos de pago permitidos y restricciones según tus políticas internas.
            </p>
        </div>
        <div class="micrositio-image">
            <img :src="a61" alt="Micrositio de facturación">
        </div>
    </div>
</template>

<script>
export default {
    name: 'MicrositioNew',
    data() {
        return {
            a61: require('@/assets/images/a61.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.micrositio-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.micrositio-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.micrositio-image img {
    width: 400px;
    height: auto;
}

.micrositio-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.micrositio-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.micrositio-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .micrositio-title {
        font-size: 60px;
    }

    .micrositio-text {
        font-size: 27px;
    }

    .micrositio-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .micrositio-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .micrositio-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .micrositio-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .micrositio-image img {
        width: 80%;
        max-width: 320px;
    }

    .micrositio-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .micrositio-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
